export interface Feedback {
  categoryId: number;
  subCategory: string;
  sentiment?: string;
  text?: string;
  sellType: string;
  url: string;
  step: string;
  listingId?: number;
}
